import React from 'react';
import { useTranslation } from 'react-i18next';
import {Block, Title} from '../../../components/components';
import { useHistory } from 'react-router';
import useCustomTable from "../../../components/tables/useCustomTable";
import Table from "../../../components/tables/Table";
import TableSearch from "../../../components/tables/TableSearch";
import Pagination from "../../../components/tables/Pagination";
import FormButton from "../../../components/forms/FormButton";
import FilterButton, {FilterGroup} from "../../../components/FilterButton";

import { useGetDataVendorsQuery } from '../../../api/dataVendorApiSlice'
import { Loader } from '../../../components/components';

function DataVendorsList(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { data: dataVendors = [], isSuccess, isLoading } = useGetDataVendorsQuery()

  const columns = [{
    Header: 'Name',
    accessor: 'name'
  },{
    Header: 'Environment',
    accessor: 'environment'
  },{
    Header: 'Bucket',
    accessor: 'bucket',
  }];

  const tableOptions = {
    sortable: true,
    paginate: true
  };

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tableFilterProps,
  } = useCustomTable(tableOptions)

  const showDataVendor = (data) => history.push(`/data_vendors/${data.slug}`)

  return (
    <>
      <Title main={t("menu.data_vendors")}>
        <FormButton new />
      </Title>
      <FilterGroup {...tableFilterProps}>
        <FilterButton
          title={t("dataVendor.environment")}
          options={["Production", "Test", "Terminated"]}
          search={false}
          includeAll={false}
          name="environment"/>
        <TableSearch {...tableSearchProps} style={{float: "right"}}/>
      </FilterGroup>
      <Block className="mb-0">
        <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
          <Table
            data={dataVendors}
            columns={columns}
            onRowClick={showDataVendor}
            {...tableProps} />
          </Loader>
      </Block>
      <Pagination {...paginationProps}/>
    </>
  )
}

export default DataVendorsList
